import React from 'react';

export const addChip = (
  chips: string[],
  setChips: React.Dispatch<React.SetStateAction<string[]>>,
  onChipsChange: (chips: string[]) => void,
  chip: string
) => {
  const trimmedChip = chip.trim();
  if (trimmedChip) {
    const newChips = [...chips, trimmedChip];
    setChips(newChips);
    onChipsChange(newChips);
  }
};

export const removeLastChip = (
  chips: string[],
  setChips: React.Dispatch<React.SetStateAction<string[]>>,
  onChipsChange: (chips: string[]) => void
) => {
  if (chips.length > 0) {
    const lastChipIndex = -1;
    const newChips = chips.slice(0, lastChipIndex);
    setChips(newChips);
    onChipsChange(newChips);
  }
};
